import i18n from '@quizzach/i18n';

export const renderDifficulty = (level: number) => {
	switch (level) {
		case 1:
			return i18n.t('quiz.difficulty.easy');
		case 2:
			return i18n.t('quiz.difficulty.medium');
		case 3:
			return i18n.t('quiz.difficulty.hard');
		default:
			return i18n.t('common.difficulty.undefined');
	}
};
